import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Select, FormControl } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import {
  createMuiTheme,
  makeStyles,
  ThemeProvider,
} from '@material-ui/core/styles';
import { CYCLE_TYPE } from '../../../shared/utils/constants';
import BootstrapInput from '../../../shared/components/BootstrapInput';

const OptionsStepCard = (props) => {
  const { t, handleChange, duration, disabled } = props;
  const useStyles = makeStyles(() => ({
    formControl: {
      backgroundColor: '#fff',
      border: '1px solid #e0e1e2;',
      color: '#30313F',
      paddingBottom: '2px',
      height: '32px',
    },
    Select: {
      maxWidth: 150,
      fontSize: 13,
      color: '#30313F',
      height: '2rem',
    },
    span: {
      color: '#808080',
    },
  }));

  const theme = createMuiTheme({
    overrides: {
      MuiSelect: {
        select: {
          '&:focus': {
            backgroundColor: '#fff',
            color: 'red',
          },
        },
      },
    },
  });

  const classes = useStyles();

  const durations = [
    { value: CYCLE_TYPE.A, label: t(`cycle-type.${CYCLE_TYPE.A}`) },
    { value: CYCLE_TYPE.S, label: t(`cycle-type.${CYCLE_TYPE.S}`) },
    { value: CYCLE_TYPE.T, label: t(`cycle-type.${CYCLE_TYPE.T}`) },
    { value: CYCLE_TYPE.B, label: t(`cycle-type.${CYCLE_TYPE.B}`) },
    { value: CYCLE_TYPE.M, label: t(`cycle-type.${CYCLE_TYPE.M}`) },
  ];

  const menuCategories = durations.map((item) => (
    <MenuItem key={item.value} value={item.value} className={classes.Select}>
      {item.label}
    </MenuItem>
  ));

  const cycleChange = (value) => {
    return durations.find((cl) => cl.value === value);
  };

  return (
    <ThemeProvider theme={theme}>
      <FormControl variant="outlined" className={classes.formControl}>
        <Select
          displayEmpty
          input={<BootstrapInput />}
          className={classes.Select}
          disabled={disabled}
          value={duration}
          required
          renderValue={
            duration !== ''
              ? undefined
              : () => (
                  <span className={classes.span}>
                    {t('placeholder.course.select')}
                  </span>
                )
          }
          onChange={(event) => handleChange(cycleChange(event.target.value))}
        >
          {menuCategories}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

OptionsStepCard.propTypes = {
  t: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  duration: PropTypes.string,
  disabled: PropTypes.bool,
};

OptionsStepCard.defaultProps = {
  duration: '',
  disabled: false,
};

export default withTranslation('common')(memo(OptionsStepCard));
